import {
	Box,
	Button,
	Heading,
	Stack,
	Text,
	FormControl,
	Input,
	Flex,
	Alert,
	AlertIcon,
	AlertTitle,
	AlertDescription,
	Icon,
	InputGroup,
	InputRightElement,
} from '@chakra-ui/react'
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom'
import LabelDivider from '../../components/LabelDivider'
import AuthLayout from '../../layouts/AuthLayout'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { login } from '../../redux/auth/authActions'
import { useState } from 'react'
import { FaLongArrowAltLeft } from 'react-icons/fa'
import { BiShow, BiHide } from 'react-icons/bi'

// import SocialAuthenticationCard from '../../components/SocialAuthenticationCard'
const AuthSignin = () => {
	const navigate = useNavigate()
	const { state } = useLocation()
	const [redirectPath] = useState(state?.from?.pathname || '/')
	const dispatch = useDispatch()
	const { user } = useSelector((state) => state.auth)
	const { loginErrors } = useSelector((state) => state.auth)
	const { loading } = useSelector((state) => state.auth)
	const [showPass, setShowPass] = useState(false)

	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm()

	const handleSignin = (data) => {
		dispatch(
			login(data, 'login', (message, status) => {
			  // After login success, navigate to the previous location or default
			  if (status === 'success') {
				navigate(redirectPath);  // Navigate back to the previous path or default
			  }
			})
		  );
	}

	if (user) {
		if (user?.role !== 'admin') return <Navigate to={redirectPath} />
		return <Navigate to="/admin/dashboard" />
	}

	return (
		<AuthLayout>
			<Box mx={'auto'} maxW={'420px'}>
				<Text
					as={Link}
					to={'/'}
					mb={'3'}
					fontWeight={500}
					color={'gray.500'}
					display={'flex'}
					alignItems={'center'}
					textTransform={'uppercase'}
				>
					<Icon as={FaLongArrowAltLeft} me={3} /> Back to home
				</Text>
				<Heading as="h3" fontSize={'28px'}>
					Sign In
				</Heading>
				<Text mt="2" mb={'5'}>Welcome back! Please sign in to continue.</Text>

				{/* <SocialAuthenticationCard /> */}

				{loginErrors?.email[0] && (
					<Alert status="error" mb={'5'}>
						<AlertIcon />
						<Box>
							<AlertTitle mr={2}>Login Error</AlertTitle>
							<AlertDescription>{loginErrors?.email[0]}</AlertDescription>
						</Box>
					</Alert>
				)}
				<Stack gap={'3'} as="form" onSubmit={handleSubmit(handleSignin)}>
					<FormControl>
						<Input
							size={'lg'}
							id="email"
							type="email"
							placeholder="Email Address"
							isInvalid={errors.email?.type === 'required'}
							{...register('email', {
								required: true,
								pattern: {
									value: /\S+@\S+\.\S+/,
									message: 'Entered value does not match email format',
								},
							})}
						/>
						<Text color="red">
							{errors.email?.type === 'required' && 'Email is required'}
						</Text>
						{errors.email?.message && (
							<Text color="red">{errors.email?.message}</Text>
						)}
					</FormControl>
					<FormControl>
						<Flex alignItems={'center'} justify={'space-between'}></Flex>
						<InputGroup size={'lg'}>
							<Input
								size={'lg'}
								id="password"
								type={showPass ? 'text' : 'password'}
								placeholder="Password"
								isInvalid={errors.password?.type === 'required'}
								{...register('password', { required: true })}
							/>
							<InputRightElement>
								<Icon
									_hover={{ cursor: 'pointer' }}
									as={showPass ? BiHide : BiShow}
									onClick={() => setShowPass(!showPass)}
								/>
							</InputRightElement>
						</InputGroup>
						<Text color="red">
							{errors.password?.type === 'required' && 'Password is required'}
						</Text>
						<Text
							as={Link}
							to={'/forget-password'}
							mt="2"
							color="brand.500"
							textDecoration={'underline'}
						>
							Forgot password?
						</Text>
					</FormControl>

					<Text fontSize={'sm'} as="em" color={'gray.500'}>
						By proceeding, you agree to terms of Services and Policies of the
						Rental Directory platform
					</Text>

					<Button
						type="submit"
						w={'full'}
						size={'lg'}
						variant={'brand'}
						isLoading={loading}
						loadingText="Signing in..."
					>
						Sign In
					</Button>

					<Text>
						Don't have an account?{' '}
						<Text as={Link} color={'brand.500'} to="/register">
							Create an account
						</Text>
					</Text>
				</Stack>
			</Box>
		</AuthLayout>
	)
}

export default AuthSignin
